<template>
    <div class="mainbody" style="min-height: 40vw;">
        <PCNavbar selectIndex="4"/>
        <MobileNavBar :currentActive="3" />
        <!-- <img class="top-bg bannerImgcss0" src="../../assets/img3/yewubankuai1/xiandaiwuliu-title-bg.png" alt="" /> -->
        <img class="top-bg bannerImgcss0" src="../../assets/8.4/truckImg.png" alt="" />


        <div class="menus" v-scroll-animate="'slide-itemgk'" style="width: 90vw; margin:0 auto;">
            <a href="/home"><i class="el-icon-s-home"></i></a> / <a href="/businessDetail?title=%25E7%258E%25B0%25E4%25BB%25A3%25E7%2589%25A9%25E6%25B5%2581">现代物流</a> /服务详情
          </div>

        <div class="detailContainer" >
         
         
            <!-- 模块1 -->
        
          <div class="childContent"  v-for="(item,index) in segmentsList" :key="index" >
            <!-- {{ this.queryIndex == index || this.queryIndex==null }} -->
           
            <div class="flexContainerDiv"  v-if="queryIndex == index || queryIndex==null" > 
                 <div class="imgDiv"> 
                        <CarouselHomeyewubankuaiNew class="showImg" :ref="'carusel'+index" :imgList="item.photo.split('|').slice(1)" :heightParam="heightParam" />
                 </div>
                 <div class="detailDiv detailDiv1"> 
                   <h1>{{ item.names }} </h1>
                    <!-- {{ item.content }} -->
                   <p v-html="item.content">
                    
                   </p>
                  
                 </div>
             </div>
          </div>

         



        </div>
     </div>
  </template>
  
  <script>
  // import childVue1 from '@/components/businessDetail/detailPageComponents/child1.vue'
  // import childVue2 from '@/components/businessDetail/detailPageComponents/child2.vue'
  // import childVue3 from '@/components/businessDetail/detailPageComponents/child3.vue'
  // import childVue4 from '@/components/businessDetail/detailPageComponents/child4.vue'
  // import childVue5 from '@/components/businessDetail/detailPageComponents/child5.vue'
  // import childVue6 from '@/components/businessDetail/detailPageComponents/child6.vue'
  // import childVue7 from '@/components/businessDetail/detailPageComponents/child7.vue'
  // import childVue8 from '@/components/businessDetail/detailPageComponents/child8.vue'
  
  import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CarouselHomeyewubankuai from '@/components/carousel_home/indexyewubankuai.vue'
import CarouselHomeyewubankuaiNew from '@/components/carousel_home/indexyewubankuaiNew.vue'
import API from '@/api/bsInfo'


  export default {
   components: {
    PCNavbar,
    MobileNavBar,
    CarouselHomeyewubankuaiNew,
    CarouselHomeyewubankuai,
    // childVue1,
    // childVue2,
    // childVue3,
    // childVue4,
    // childVue5,
    // childVue6,
    // childVue7,
    // childVue8,
   },
   data() {
     return {
      urlBase: process.env.VUE_APP_BASE_API,
      heightParam:'24vw',
       queryIndex:null,
    
      segmentsList:[],
       
     }
   },
   
   props: {
     
   },
   created() {
    this.queryIndex = this.$route.query.index;
    this.zhongoubanlieData();
     
  },
  mounted() {
    
   },
   methods: {
     //获取中欧班列页面数据
   async zhongoubanlieData() {
      try {
        let objParams={
          catId:'d3763ecc99d14860934e4fdc09c8c997'
        }
        const res = await API.zhongoubanlieData(objParams)
        this.$nextTick(()=>{
         
          this.segmentsList=res.data.segmentsList
          console.log('获取成功', res.data.resultData)
        })
       
      } catch (error) {
        console.error('获取失败', error)
      }
    },
    changeTargetPosition(index) {
      let objID='childContent'+index
      const element = document.getElementById(objID);
      element.scrollIntoView({ 
        behavior: 'smooth', // 平滑滚动
        block: 'start'      // 对齐到顶部（可选：'center'/'end'）
      });

     
     
    },
   },
  }
  </script>
  
  <style lang="scss" scoped>
  
   .detailContainer{
     width: 90vw;
     margin:0 auto;
     border:1px solid #e5e5e5;
     padding-bottom:1rem;
     margin-bottom: 1rem;
     // background: #dde8f4;
     // margin-block: 100px;
     // background:url('../../assets/img3/gaikuang1/chanyepng.png');
   // background-size: 100% 100%;
   // .modules0{
   // 	width: 100%;
   // 	margin: 0 auto;
   // }
      
   }
//    .menus{
//     width: 90%;
//     margin:0 auto;
//     padding:1rem;
//     padding-left: 0;
//     font-size:1rem;
//     a{
//       color:#015293;
//     }
//  }

 .childContent{
     width: 89vw;
     margin:0 auto;
     margin-top: 1rem;
    //  border: 1px solid #000000;
     text-align: center;
     // background: #dde8f4;
     // margin-block: 100px;
     // background:url('../../assets/img3/gaikuang1/chanyepng.png');
   // background-size: 100% 100%;
   // .modules0{
   // 	width: 100%;
   // 	margin: 0 auto;
   // }
      h1{
        font-size: 1.2rem;
      }
      .flexContainerDiv{
        display: flex;
        // background: #f5f5f58c;
        padding-right: 1rem;
        @media screen and (max-width: 768px) {
            flex-direction: column;
            padding-right: 0;
          }
        gap: 1rem;
        .imgDiv{
          width: 36vw;
          display: flex;
           @media screen and (max-width: 768px) {
            width: 89vw;
            height: 50vw !important;
          }
          // border: 1px solid blue;
           img{
            width: 80rem !important;
            height:12rem !important;
            object-fit: cover;
            @media screen and (max-width: 768px) {
              width: 100%  !important;
              height:100% !important;
            }
           }
           div{
              width: 100%;
              img{
                display: block;
                width: 100%;
                height:4rem !important;
                object-fit: cover;
              }
            }
            div.imgDiv-1{
              width: 50%;
              img{
                display: block;
                width: 100%;
                height:12rem !important;
                object-fit: cover;
              }
            }
            div.imgDiv-2{
              img{
                height:6rem !important;
              }
            }
        }
        .detailDiv{
          flex: 60%;
         text-align: left;
         font-size: 1rem;
        //  text-indent: 2rem;
         line-height: 2.2rem;
       
         padding-top:0rem;
         color: #666666;
         box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
          /* 台式机 (可能更大或比例不同) */
        @media screen and (min-width: 1920px),
        screen and (min-width: 1600px) and (min-aspect-ratio: 16/10) {
             line-height: 2.5rem;
        }
         @media screen and (max-width: 768px) {
          padding-top: 1rem;
          }
          h1{
            // padding-bottom: 1rem;
            // margin-top:1rem;
            // margin-bottom: 1rem;
            height: 2.5;
            line-height: 2.5;
            border-bottom: 1px solid #e5e5e5;
            border-radius: 1rem 1rem 0 0;
            text-indent: 0rem;
            // background: #015293;
            background: #1969a5;
            box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
            color: #ffffff;
            text-align: center;
          }
          p{
            text-indent: 2rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 8;  /* 限制显示行数 */
            overflow: hidden;
            text-overflow: ellipsis;  /* 超出显示省略号 */
            text-align: justify !important;
            padding:1rem;
            padding-bottom:0;
             @media screen and (max-width: 768px) {
              -webkit-line-clamp: 18;  /* 限制显示行数 */
            }
          }
          ::v-deep{
            p{
              text-align: justify !important;
            }
          }
         
       }
       .detailDiv1{
        padding-top: 0rem;
       }
      }
      

   }
   ::v-deep .img_item{
    padding-top: 0 !important;
   }
   ::v-deep{
       @media only screen and (max-width: 767px)
        {
          .showImg{
            .hidden-xs-only{
                height: 50vw !important;
              display:block !important;
              .el-carousel__container{
                  height: 50vw !important;
              }
            }
          }
        }
   }

   </style>